/**
 * サイドバーアコーディオン機能
 *
 * .side-box 内の .side-toggle をクリックすると、対応する .side-content が開閉する
 */
const initSidebarAccordion = () => {
    const boxes = document.querySelectorAll('.side-box');

    boxes.forEach((box, index) => {
        const button = box.querySelector('.side-toggle');
        const content = box.querySelector('.side-content');

        if (!button || !content) return;

        // コンテンツにIDが設定されていない場合は自動生成
        const contentId = content.id || `sidebar-panel-${index}`;
        content.id = contentId;
        button.setAttribute('aria-controls', contentId);

        // クリックで開閉をトグル
        const toggle = () => {
            const isOpen = box.classList.contains('is-open');

            if (isOpen) {
                // 閉じる処理
                button.setAttribute('aria-expanded', 'false');
                box.classList.remove('is-open');

                // まず高さを0に設定（アニメーション開始）
                content.style.height = '0';

                // トランジション終了後にhiddenを設定
                const handleTransitionEnd = () => {
                    content.hidden = true;
                    content.removeEventListener('transitionend', handleTransitionEnd);
                };
                content.addEventListener('transitionend', handleTransitionEnd);
            } else {
                // 開く処理
                button.setAttribute('aria-expanded', 'true');
                box.classList.add('is-open');

                // hiddenを解除してから高さを設定
                content.hidden = false;

                // リフロー（再描画）を強制してからアニメーション開始
                // これがないとCSSトランジションが動作しない
                content.offsetHeight;

                // 実際の高さを設定（アニメーション開始）
                content.style.height = content.scrollHeight + 'px';
            }
        };

        button.addEventListener('click', toggle);
    });
};

export default initSidebarAccordion;
